


.client-side-search-bar {
  label {
    > span {
      display: none;
    }
  }
}

/**
 * TD for Magnetic table
 * .ag-cell for AGGrid
 */
td, .ag-cell {
  ::highlight(client-search-string-results) {
    background-color: #FFFF00;
    color: #000000;
  }
}

.highlight-text-for-search {
  ::highlight(client-search-string-results) {
    background-color: #FFFF00;
    color: #000000;
  }
}

